import { useLayoutEffect, useRef } from "react";
import Experience from "../../Experience/Experience";
import "./BackendExperience.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function BackendExperience() {
  const rootRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(".be-head .eyebrow", {
        y: 20, opacity: 0, duration: 0.6, ease: "power3.out",
        scrollTrigger: { trigger: ".be-head", start: "top 88%" },
      });
      gsap.from(".be-head h2", {
        y: 40, opacity: 0, duration: 0.8, ease: "power3.out",
        scrollTrigger: { trigger: ".be-head", start: "top 85%" },
      });
      gsap.from(".be-head p", {
        y: 20, opacity: 0, duration: 0.6, delay: 0.1, ease: "power3.out",
        scrollTrigger: { trigger: ".be-head", start: "top 85%" },
      });
      gsap.from(".be-grid .experience-card", {
        y: 40, opacity: 0, duration: 0.7, stagger: 0.1, ease: "power3.out",
        scrollTrigger: { trigger: ".be-grid", start: "top 88%" },
      });
    }, rootRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={rootRef} className="skills-section backend-section">
      <div className="skills-inner">
        <div className="be-head skills-head">
          <span className="eyebrow">02 — Backend</span>
          <h2>
            Backend <span className="grad-text">Development</span>
          </h2>
          <p>Scalable APIs, databases and server architecture that stays fast under load.</p>
        </div>
        <div className="be-grid skills-grid">
          <Experience name="Node JS" level="Advanced" image="node-icon.png" />
          <Experience name="Express" level="Advanced" image="express-icon.png" />
          <Experience name="MongoDB" level="Advanced" image="mongodb-icon.png" />
          <Experience name="Asp Net Core" level="Intermediate" image="aspnetcore-logo.png" />
          <Experience name="Laravel" level="Intermediate" image="laravel-logo.svg" />
        </div>
      </div>
    </section>
  );
}
